/*
  Кнопка «Выбрать счета…» рядом с записью загрузки - решение владельца
  16.10.2026: выбор отдельной кнопкой и окном, а не флажками в таблице разбора.

  Не нажимали - грузится весь файл, как раньше. После «Применить» кнопка
  называет выбор («Выбрано 40 из 221…»), и по ней же выбор правится. Счета для
  окна приносит разбор файла: если человек ещё не смотрел «что получится»,
  кнопка сама попросит разбор (`onNeed`) и откроет окно, когда он придёт.
*/

import { useState } from 'react'

import AccountPicker from './AccountPicker.jsx'

export default function PickAccounts({ choices, only, onChange, onNeed, disabled, note, amountTitle }) {
  const [open, setOpen] = useState(false)
  const [asking, setAsking] = useState(false)

  async function start() {
    if (choices) {
      setOpen(true)
      return
    }
    // Разбор приходит через `onNeed` - ошибку разбора показывает сама загрузка,
    // рядом со своими кнопками; окно при неудаче просто не открывается.
    setAsking(true)
    const ready = await onNeed()
    setAsking(false)
    if (ready) setOpen(true)
  }

  const label = only && choices ? `Выбрано ${only.length} из ${choices.length}…` : 'Выбрать счета…'
  return (
    <>
      <button
        type="button"
        className="button button--quiet"
        disabled={disabled || asking}
        onClick={start}
      >
        {label}
      </button>
      {open && choices ? (
        <AccountPicker
          choices={choices}
          initial={only}
          note={note}
          amountTitle={amountTitle}
          onApply={(numbers) => {
            setOpen(false)
            onChange(numbers)
          }}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  )
}
